import { useMutation } from '@tanstack/react-query';
import { ApiError } from '@src/services/api';
import { ApiTypes, RightRequestView } from 'common';
import { queryClient, QUERY_KEYS, QUERY_PREFIX } from '@src/query';
import { updateMediaFindData } from './useQueryMediaFind';
import { createRightsRequest } from './api';

export const useMutationRightsRequestCreate = () => useMutation<ApiTypes.ResPostRightsRequest, ApiError, {
  mediaId: string
  rightsRequest: ApiTypes.ParamsPostRightsRequest
}>({
  mutationFn: ({ mediaId, rightsRequest }) => createRightsRequest(mediaId, rightsRequest),
  onSuccess: async (res) => {
    // update optimistically for user satisfaction
    // and then refresh media to have perfectly updated results
    res.forEach((rr: RightRequestView) => {
      updateMediaFindData(rr.mediaId, { rightsRequestStatus: rr.status });
      // refetch media for detailed view
      queryClient.refetchQueries({ queryKey: QUERY_KEYS.media(rr.mediaId) });
    });
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.mediaFind() });
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.collectionsMedia() });
    queryClient.invalidateQueries({ queryKey: [QUERY_PREFIX.MEDIA_SIMILAR] });
    queryClient.invalidateQueries({ queryKey: [QUERY_PREFIX.MEDIA_CAROUSEL] });
  },
});
